import React, { createContext, useEffect, useState } from 'react';

import { EVENT_KEY } from '@/config';

import { getValue } from '@/helpers/GetValueHelper';

import { TData, TEventContext, TParams } from './types';

export const EventContext = createContext({} as TEventContext);

const EventProvider = ({ children }: TParams): JSX.Element | null => {
  const [data, setData] = useState<TData>({} as TData);
  const [openModal, setOpenModal] = useState(false);

  const createEventListener = () => {
    window.addEventListener(
      EVENT_KEY,
      e => {
        setData(getValue(e, 'detail', {}) as TData);
        setOpenModal(true);
      },
      false,
    );
  };

  const close = () => setOpenModal(false);

  useEffect(() => {
    createEventListener();
    return () => {
      setData({} as TData);
      setOpenModal(false);
    };
  }, []);

  return (
    <EventContext.Provider
      value={{
        data,
        isOpen: openModal,
        close,
      }}
    >
      {children}
    </EventContext.Provider>
  );
};

export default EventProvider;
